export var SparkEngineSortField;
(function (SparkEngineSortField) {
    SparkEngineSortField["SPARK_ENGINE_SORT_FIELD_CREATED_AT"] = "createdAt";
    SparkEngineSortField["SPARK_ENGINE_SORT_FIELD_UPDATED_AT"] = "updatedAt";
    SparkEngineSortField["SPARK_ENGINE_SORT_FIELD_NAME"] = "name";
    SparkEngineSortField["SPARK_ENGINE_SORT_FIELD_EON_SPARK_VERSION"] = "eonSparkVersion";
    SparkEngineSortField["SPARK_ENGINE_SORT_FIELD_MAX_VCPU"] = "maxVcpu";
    SparkEngineSortField["SPARK_ENGINE_SORT_FIELD_MAX_MEMORY"] = "maxMemory";
    SparkEngineSortField["SPARK_ENGINE_SORT_FIELD_MAX_STORAGE"] = "maxStorage";
    SparkEngineSortField["SPARK_ENGINE_SORT_FIELD_CONCURRENT_JOBS"] = "concurrentJobs";
})(SparkEngineSortField || (SparkEngineSortField = {}));
